/**
 * DescriptionBackgroundContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled detail background container.
 */
const DescriptionBackgroundContainer = styled.div`
  position: absolute;
  height: 100vh;
  width: 100vw;
`;

export default withOpacity(DescriptionBackgroundContainer);
